import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col py-12px justify-start" }
const _hoisted_2 = { class: "items flex gap-[3%] flex-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "template-card w-[100%] h-[100%] overflow-hidden border border-solid border-[#e5e5e5] rounded-md flex items-center justify-center",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "caption" }
const _hoisted_7 = { key: 0 }

import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElEmpty } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted, watch } from 'vue'
import { getResourceList } from '@/api/affairs'

export default /*@__PURE__*/_defineComponent({
  __name: 'template',
  props: {
  id: {
    type: Number,
    default: 0
  }
},
  setup(__props) {

const props = __props
watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    getList()
  }
})
onMounted(() => {
  getList()

})
const resourceList = ref([])
const getList = () => {
  getResourceList({
    pageNum: 1, pageSize: 30, file_type: 1, folder_id: props.id
  }).then(res => {
    resourceList.value = res.data.data.items
  })
}

const handleClick = (item: any) => {
  window.open(`/editor?id=${item.id}&mode=user`)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "w-[30%] h-[150px] cursor-pointer",
          onClick: ($event: any) => (handleClick(item))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: item.full_preview_url,
              alt: "",
              class: "w-[100%] rounded"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)
          ])
        ], 8, _hoisted_3))
      }), 128))
    ]),
    (resourceList.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(ElEmpty), { description: "暂无数据" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})